var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38079 6.4585L5.95222 6.45851C3.91346 6.45851 2.2915 8.06004 2.2915 9.99819C2.2915 11.6689 3.4944 13.0877 5.13442 13.4493C5.39676 13.5072 5.6704 13.5379 5.95222 13.5379C6.2974 13.5379 6.57722 13.8177 6.57722 14.1629C6.57722 14.5081 6.2974 14.7879 5.95222 14.7879C5.57939 14.7879 5.21551 14.7473 4.86526 14.67C2.68815 14.19 1.0415 12.2915 1.0415 9.99819C1.0415 7.33617 3.2571 5.20851 5.95222 5.20851L7.38079 5.2085C10.0843 5.2085 12.2915 7.58002 12.2915 9.99819C12.2915 10.3434 12.0117 10.6232 11.6665 10.6232C11.3213 10.6232 11.0415 10.3434 11.0415 9.99819C11.0415 8.26349 9.38709 6.4585 7.38079 6.4585Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6189 13.5379L14.0475 13.5379C16.0862 13.5379 17.7082 11.9363 17.7082 9.99818C17.7082 8.32743 16.5053 6.90866 14.8653 6.54703C14.6029 6.48919 14.3293 6.4585 14.0475 6.4585C13.7023 6.4585 13.4225 6.17867 13.4225 5.8335C13.4225 5.48832 13.7023 5.2085 14.0475 5.2085C14.4203 5.2085 14.7842 5.24913 15.1344 5.32636C17.3115 5.80642 18.9582 7.70491 18.9582 9.99818C18.9582 12.6602 16.7426 14.7879 14.0475 14.7879L12.6189 14.7879C9.91536 14.7879 7.70817 12.4164 7.70817 9.99818C7.70817 9.653 7.98799 9.37318 8.33317 9.37318C8.67835 9.37318 8.95817 9.653 8.95817 9.99818C8.95817 11.7329 10.6126 13.5379 12.6189 13.5379Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.d394727f8db63cbc02e7eb5a1d31d121.svg";
export { ForwardRef as ReactComponent };